module.exports = __webpack_public_path__ + "assets/img/users_128.d0d32ead.png";